/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import Friends from '../../components/friends';
import AddFriend from '../../components/addFriend';
import FriendScanner from '../../components/friendScanner';
import theme from '../../constants/theme.style.js';

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    height: '100%',
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingTop: 10,
    padding: 20,
  },
  centerWrap: {
    flex: 1,
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
  header: {
    marginTop: theme.CONTAINER_MARGIN * 1,
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE * 3,
    fontFamily: 'Pacifico',
    marginTop: 10,
    marginLeft: width < 900 ? theme.CONTAINER_MARGIN * 2 : 0,
  },
});

export default class FriendsScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addFriend: false,
    };
  }

  toggleAddFriend = () => {
    const { addFriend } = this.state;
    this.setState({
      addFriend: !addFriend,
    });
  };

  render() {
    const { addFriend } = this.state;
    const { navigation } = this.props;

    if (!addFriend) {
      return (
        <View style={styles.container}>
          <View style={styles.header}>
            <View style={styles.centerWrap}>
              <CustomText style={styles.headerText}>Friends</CustomText>
            </View>
            <FriendScanner />
          </View>
          <View style={styles.body}>
            <View style={styles.centerWrap}>
              <AddFriend
                callback={this.toggleAddFriend}
                showAddFriend={false}
                text="Add friend +"
              />
              <Friends nav={navigation} />
            </View>
          </View>
        </View>
      );
    }
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.headerText}>Friends</CustomText>
          </View>
          <FriendScanner />
        </View>
        <View style={styles.body}>
          <View style={styles.centerWrap}>
            <AddFriend
              style={styles.header}
              callback={this.toggleAddFriend}
              showAddFriend
              text="Done adding friends"
            />
          </View>
        </View>
      </View>
    );
  }
}
